module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "root"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "item-first"
  }, [_c('div', {
    staticClass: "item-qrcode"
  }, [_c('div', {
    ref: "qrcode",
    staticClass: "qrcode",
    attrs: {
      "id": "qrcode"
    }
  })]), _vm._m(0)]), _vm._m(1), _vm._m(2)]), _c('img', {
    attrs: {
      "src": require("./images/serviceProvider/bg-bottom.png")
    }
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-content"
  }, [_c('span', [_vm._v("“万众创业贷(猪八戒)”是猪八戒网平台与重庆三峡银行联合打造的面向广大服务商的订单融资产品，以服务商的交易订单为依据，以金融科技手段为支撑，为猪八戒网的广大服务商提供“线上申请、智能审批、实时到账、方便快捷”的全流程全线上融资服务。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-second"
  }, [_c('img', {
    staticClass: "title",
    attrs: {
      "src": require("./images/serviceProvider/title-product.png")
    }
  }), _c('div', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-card"
  }, [_c('img', {
    attrs: {
      "src": require("./images/serviceProvider/icon-jike.png")
    }
  }), _c('span', [_vm._v("即刻贷")]), _c('i', [_vm._v("60s全线上申请"), _c('br'), _vm._v("最快3分钟到账")]), _c('i')]), _c('div', {
    staticClass: "item-card"
  }, [_c('img', {
    attrs: {
      "src": require("./images/serviceProvider/icon-diya.png")
    }
  }), _c('span', [_vm._v("0抵押")]), _c('i', [_vm._v("订单就能贷"), _c('br'), _vm._v("0抵押 0担保")]), _c('i')]), _c('div', {
    staticClass: "item-card"
  }, [_c('img', {
    attrs: {
      "src": require("./images/serviceProvider/icon-edu.png")
    }
  }), _c('span', [_vm._v("额度高")]), _c('i', [_vm._v("最高额度50万"), _c('br'), _vm._v("随借随还")]), _c('i')]), _c('div', {
    staticClass: "item-card"
  }, [_c('img', {
    attrs: {
      "src": require("./images/serviceProvider/icon-chengben.png")
    }
  }), _c('span', [_vm._v("成本低")]), _c('i', [_vm._v("年利率低至9.50%"), _c('br'), _vm._v("借1万元日利息仅2.64元"), _c('br'), _vm._v("(推广期内)")]), _c('i')])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-third"
  }, [_c('img', {
    staticClass: "title",
    attrs: {
      "src": require("./images/serviceProvider/title-contact.png")
    }
  }), _c('div', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-card"
  }, [_c('img', {
    attrs: {
      "src": require("./images/serviceProvider/icon-kefu.png")
    }
  }), _c('span', [_vm._v("客服热线")]), _c('i', [_vm._v("023-88392602")])]), _c('div', {
    staticClass: "item-card"
  }, [_c('img', {
    staticClass: "big",
    attrs: {
      "src": require("./images/serviceProvider/contact_qr.png")
    }
  }), _c('span', [_vm._v("微信咨询")])]), _c('div', {
    staticClass: "item-card"
  }, [_c('img', {
    attrs: {
      "src": require("./images/serviceProvider/icon-email.png")
    }
  }), _c('span', [_vm._v("邮箱")]), _c('i', [_vm._v("kangkang@zbj.com")])])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-28a402a9", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-28a402a9","preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/@zbj/vue-mixin-loader?{"mixinPath":"D://zhubajie//Project//nodejs-zbjfins-web//app//resource//global//css//mixin//mixin.less"}!./app/resource/page/index/views/serviceProvider.vue
// module id = 1189
// module chunks = 2